import React from 'react';
import { Content } from '../content';

export const LandingPage = () => {
  return (
    <>
      <Content></Content>
    </>
  )
}
